import { Subject } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { StateModel, CustomerPaymentsOutput, PaywayCustomerRequest, CurrentUserModel } from '../../models/account-ledger.model';
import { MyAccountService } from '../../services/myAccount.service';
import { CheckOutService } from '../../services/checkout.service';
import { ApiResponse } from '../../models/api-response.model';
import { enterAnimation } from '../../shared/animations.collections';
import { ccform, baform } from '../../shared/JavaScript/paymentform';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { AuthService } from '../../services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { getShoppingCartLoaded, getSelectedShoppingCart } from '../../reducers/shoppingcart.reducer';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';
import { SimpleLoadingPopupComponent } from '../../popup-collection/simple-loading/simple-loading-popup.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-setup',
  animations: [enterAnimation()],
  templateUrl: './payment-setup.component.html',
  styleUrls: ['./payment-setup.component.css']
})
export class PaymentSetupComponent implements OnInit, OnDestroy {

  setFullWindow: false;
  loadContent = false;
  title = 'Digital Wallet';
  stateList: string[];
  paymentGroup: FormGroup;
  customerPayments: CustomerPaymentsOutput[];
  paywayCustomer: PaywayCustomerRequest;
  paymentForm = true;
  cartId: number;
  cartName: string;
  singleToken: string;
  submitClass: string;
  redirectFrom: string;
  filterResultArr: any;
  filterInput: string; // binds to ngModel of filter input
  hasEmptyFilterResult = false; // checking the return value by calling filter pipe
  editMood = false;
  addMood = false;
  selectedPaymentMethod: string;
  createNew = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  apiKey: string;
  currentUrl: string;
  currentUserModel: CurrentUserModel;
  paymentMethods = [
    { value: 'creditcard', viewValue: 'Credit Card' },
    { value: 'bankaccount', viewValue: 'Bank Account' }
  ];

  constructor(
    private router: Router
    , private activatedRoute: ActivatedRoute
    , private formBuilder: FormBuilder
    , private commonService: CommonService
    , private shoppingCartService: ShoppingCartService
    , private myAccountService: MyAccountService
    , private checkOutService: CheckOutService
    , private authService: AuthService
    , private store: Store<AppState>
    , private dialog: MatDialog
    , public ngProgress: NgProgressService) {
    this.initialAddress();
  }

  ngOnInit() {

    $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);

    this.currentUrl = this.router.url;
    this.myAccountService.GetCurrentPublishableKey().subscribe((key: string) => {
      this.apiKey = key;
    },
      (error: any) => {
        console.error(error);
      });

    this.activatedRoute.queryParamMap.subscribe(param => {
      this.createNew = param.get('createNew') === 'true' ? true : false;

      if (this.createNew) {
        this.newDigitalWallet();
      }

      if (param.get('dwadded') === '1') {
        this.commonService.implementToast('Your payment information successfully saved and ready to use to make payment', 'Success');
      }
    });

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.error(error);
      });

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;

      // if (this.currentUserModel.hasAdminAccess) {
        this.checkOutService.GetSubscriptionPaymentMethodList().pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((res: CustomerPaymentsOutput[]) => {
            this.customerPayments = res;
  
          },
            (error: any) => {
              console.error(error);
            });
      // } else {
      //   this.checkOutService.GetPaymentMethodList().pipe(takeUntil(this.ngUnsubscribe))
      //     .subscribe((res: CustomerPaymentsOutput[]) => {
      //       this.customerPayments = res;
      //     },
      //       (error: any) => {
      //         console.error(error);
      //       });
      // }
    },
      (error: any) => {
        console.error(error);
      });

    this.store.select(getShoppingCartLoaded).subscribe((isLoaded) => {
      if (isLoaded) {
        this.store.select(getSelectedShoppingCart).subscribe(cart => {
          if (cart) {
            this.cartId = cart.cartId;
            this.cartName = cart.cartName;
          }
        });
      }
    });

    // this.shoppingCartService.currentCartId.subscribe((res: number) => {
    //   this.cartId = res;
    //   this.shoppingCartService.getCartName(this.cartId.toString()).subscribe((result: string) => {
    //     this.cartName = result;
    //   },
    //     (error: any) => {
    //       console.error(error);
    //     });
    // },
    //   (error: any) => {
    //     console.error(error);
    //   });

    this.checkOutService.addNewPaymentWatch.subscribe((res: string) => {
      this.redirectFrom = res;
    },
      (error: any) => {
        console.error(error);
      });

  }

  initialAddress(): void {
    this.paymentGroup = this.formBuilder.group({
      newPaymentGroup: this.getNewPaymentGroup()
    });
  }

  getNewPaymentGroup(): FormGroup {
    return this.formBuilder.group({
      customerName: new FormControl('', [Validators.required]),
      emailAddress: new FormControl(''),
      street1: new FormControl(''),
      street2: new FormControl(''),
      cityName: new FormControl(),
      state: new FormControl(''),
      postalCode: new FormControl(''),
      phoneNumber: new FormControl(''),
      paywayPersonalUse: new FormControl(''),
      maxAuthorisedAmount: new FormControl('')
    });
  }

  isNotValidField(path: string, validateClass: any): void {
    if (this.paymentGroup.get(path).hasError('required')) {
      this.commonService.showValidator(validateClass, 'Please name your payment option', 'right', 'error');
    }
  }

  deletePayment(payment: CustomerPaymentsOutput): void {
    this.ngProgress.start();
    this.checkOutService.DeletePaywayCustomer(payment.out_customer_number).subscribe((res: ApiResponse) => {
      if (res && res.status) {
        this.commonService.showSuccess(`#${payment.out_customer_number}`, 'Delete Successful', 'right');
      } else {
        this.commonService.showError(`#${payment.out_customer_number}`, 'Delete Failed', 'right');
      }
      setTimeout(() => {
        this.checkOutService.GetPaymentMethodList().subscribe((results: CustomerPaymentsOutput[]) => {
          this.customerPayments = results;
        },
          (error: any) => {
            console.error(error);
          });
      }, 1000);
      this.ngProgress.done();
    },
      (error: any) => {
        console.error(error);
        this.commonService.showError(`#${payment.out_customer_number}`, 'Delete Failed', 'right');
        this.ngProgress.done();
      });
  }

  showCCForm(): void {
    this.selectedPaymentMethod = 'creditcard';
    $('.cc').attr('disabled', 'disabled');
    $('.ba').removeAttr('disabled');
    setTimeout(() => {
      ccform(this.apiKey);
    }, 100);
  }

  showBAForm(): void {
    this.selectedPaymentMethod = 'bankaccount';
    $('.ba').attr('disabled', 'disabled');
    $('.cc').removeAttr('disabled');
    setTimeout(() => {
      baform(this.apiKey);
    }, 100);
  }

  registerPayment(): void {
    if (this.paymentGroup.valid) {
      this.checkOutService.SetPaywayCustomer(this.paymentGroup.get('newPaymentGroup').value).subscribe((res: PaywayCustomerRequest | ApiResponse) => {
        if ((res as ApiResponse)?.status == false) {
          this.commonService.implementToast((res as ApiResponse)?.responseMessage, 'Error')
      } else { 
        this.paywayCustomer = res as PaywayCustomerRequest;
        this.paymentForm = false;
        if (this.selectedPaymentMethod === 'creditcard') {
          this.showCCForm();
        } else if (this.selectedPaymentMethod === 'bankaccount') {
          this.showBAForm();
        }
      }
      },
        (error: any) => {
          console.error(error);
        });
    } else {
      this.isNotValidField('newPaymentGroup.customerName', '.customerNameValidate');
    }
  }

  backToForm(): void {
    this.paymentForm = true;
  }

  paywayLanding(type: string): void {
    this.ngProgress.start();
    this.submitClass = type === 'cc' ? 'payway-cc-submit' : 'payway-ba-submit';
    setTimeout(() => {
      this.singleToken = $('#msg').html();
      this.checkOutService.PaywayLanding(this.paywayCustomer, this.singleToken).subscribe((res: ApiResponse) => {
        if (res.status) {
          this.commonService.implementToast(res.responseMessage, 'Success');
          setTimeout(() => {
            if (this.redirectFrom === 'PAYMENT') {
              // this.router.navigateByUrl('/myCarts/cart/'+this.cartId+'/'+this.cartName+'/payment-method');
              this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });
            } else {
              this.checkOutService.GetPaymentMethodList().subscribe((model: CustomerPaymentsOutput[]) => {
                this.customerPayments = model;
                // $('#pills-home-tab').removeClass('active').removeClass('show').attr("aria-selected", "false");
                // $('#pills-profile-tab').addClass('active').addClass('show').attr("aria-selected", "true");
                // $('#pills-tabContent #new-payment').removeClass('active').removeClass('show').attr("aria-selected", "false");
                // $('#pills-tabContent #list-payment').addClass('active').addClass('show').attr("aria-selected", "true");
              },
                (error: any) => {
                  console.error(error);
                });
            }
          }, 1000);
        } else {
          this.commonService.implementToast(res.responseMessage, 'Error');
        }
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
      this.ngProgress.done();
    }, 1500);
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.customerPayments, ['out_account_name'], this.filterInput);
    // console.log(this.filterResultArr);
    if (this.filterResultArr.length === 0) {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
    // onsole.log(this.hasEmptyFilterResult);
  }

  newDigitalWallet() {
    const url = this.router.url;
    if (!this.currentUserModel.isAU) {
      window.open(this.myAccountService.createNewPaymentIdWindcave(), '_blank').focus();
    } else {
      this.addMood = true;
      this.editMood = false;
      if (url.includes('openorders') && !url.includes('openorders/orderitemdetail')) {   // used in open orders
        $('.combination-loader').animate(
          { scrollLeft: (5000) },
          {
            duration: 400,
            complete: function () {
              $('.combination-loader').stop(true, false);
            }
          });
      }
    }
  }

  enableDisablePaywayCustomer(event: any, payment: CustomerPaymentsOutput) {
    if (!event.checked) {
      this.checkOutService.DisablePaywayCustomer(payment.out_customer_number).subscribe((res: any) => {

        if (res && res.status === true) {
          payment.out_valid = "N";
          this.commonService.implementToast('Future payments has been disabled successfully', 'Info');
        }
      },
        (error: any) => {
          console.error(error);
          payment.out_valid = "Y";
          this.commonService.implementToast('Disable Payway Customer Failed', 'Error');
        });
    } else {
      this.checkOutService.EnablePaywayCustomer(payment.out_customer_number).subscribe((res: any) => {
        if (res && res.status === true) {
          payment.out_valid = "Y";
          this.commonService.implementToast('Future payments has been enabled successfully', 'Success');
        }
      },
        (error: any) => {
          payment.out_valid = "N";
          console.error(error);
          this.commonService.implementToast('Enable Payway Customer Failed', 'Error');
        });
    }
  }

  closeRightPanel() {
    this.editMood = false;
    this.addMood = false;
    this.paymentGroup.reset();
    this.paymentForm = true;
    this.selectedPaymentMethod = '';
  }

  close() {
    this.ngProgress.done();

    const urlPath = this.router.url;

    if (urlPath.includes('cart')) {   // used in checkout
      this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute.parent });

    } else {
      this.router.navigate(['../'], { relativeTo: this.activatedRoute });
    }

  }


  onLoading(currentLoadingStatus: boolean) {

    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
